import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';
import { numWord } from '@features/tickets-new-type-simple-tree/organisms/ticket-type-select/helpers/numWord';
import * as Styled from './styled';

export const NoTypeCheckbox = ({
  name,
  label,
  affectTo,
  defaultValue,
}: {
  name: string;
  label: string;
  affectTo: {
    name: string;
    checkedValue: number;
    setFieldValue: (field: string, value: any) => void;
  };
  defaultValue?: boolean;
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(defaultValue ?? false);
  const amountTickets = affectTo.checkedValue;

  if (!amountTickets) return null;

  const onChange = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    setValue(checked);
    affectTo.setFieldValue(name, checked);
  };

  const chipLabel = `${amountTickets} ${numWord(
    amountTickets,
    t('SubstituteWorker.ticketOne'),
    t('SubstituteWorker.ticketTwo'),
    t('SubstituteWorker.ticketFive')
  )}`;

  return (
    <Styled.TreeItemWrapper>
      <FormControlLabel
        name={name}
        control={<Checkbox size="small" value={value} onChange={onChange} />}
        label={<Typography variant="body2">{label}</Typography>}
      />

      {!!value ? (
        <Styled.Chip label={chipLabel} size="small" color={'primary'} />
      ) : (
        <Styled.Chip label={chipLabel} size="small" variant={'outlined'} />
      )}
    </Styled.TreeItemWrapper>
  );
};
